<div>
    <div class="row justify-content-center">
        <div class="col-md-8">
            <h2 *ngIf="settingsForm.get('login').value">User settings for [<strong>{{settingsForm.get('login').value}}</strong>]</h2>

            <div class="alert alert-success" *ngIf="success">
                <strong>Settings saved!</strong>
            </div>


            <form name="form" role="form" (ngSubmit)="save()" [formGroup]="settingsForm" *ngIf="settingsForm.get('login').value" novalidate>

                <div class="form-group">
                    <label class="form-control-label" for="firstName">First Name</label>
                    <input type="text" class="form-control" id="firstName" name="firstName" placeholder="{{'settings.form.firstname.placeholder' | translate}}"
                           formControlName="firstName">
                    <div *ngIf="settingsForm.get('firstName').invalid && (settingsForm.get('firstName').dirty || settingsForm.get('firstName').touched)">
                        <small class="form-text text-danger"
                           *ngIf="settingsForm.get('firstName').errors.required">
                            Your first name is required.
                        </small>
                        <small class="form-text text-danger"
                           *ngIf="settingsForm.get('firstName').errors.minlength">
                            Your first name is required to be at least 1 character.
                        </small>
                        <small class="form-text text-danger"
                           *ngIf="settingsForm.get('firstName').errors.maxlength">
                            Your first name cannot be longer than 50 characters.
                        </small>
                    </div>
                </div>
                <div class="form-group">
                    <label class="form-control-label" for="lastName">Last Name</label>
                    <input type="text" class="form-control" id="lastName" name="lastName" placeholder="{{'settings.form.lastname.placeholder' | translate}}"
                           formControlName="lastName">
                    <div *ngIf="settingsForm.get('lastName').invalid && (settingsForm.get('lastName').dirty || settingsForm.get('lastName').touched)">
                        <small class="form-text text-danger"
                           *ngIf="settingsForm.get('lastName').errors.required" >
                            Your last name is required.
                        </small>
                        <small class="form-text text-danger"
                           *ngIf="settingsForm.get('lastName').errors.minlength">
                            Your last name is required to be at least 1 character.
                        </small>
                        <small class="form-text text-danger"
                           *ngIf="settingsForm.get('lastName').errors.maxlength">
                            Your last name cannot be longer than 50 characters.
                        </small>
                    </div>
                </div>
                <div class="form-group">
                    <label class="form-control-label" for="email">Email</label>
                    <input type="email" class="form-control" id="email" name="email" placeholder="{{'global.form.email.placeholder' | translate}}"
                           formControlName="email">
                    <div *ngIf="settingsForm.get('email').invalid && (settingsForm.get('email').dirty || settingsForm.get('email').touched)">
                        <small class="form-text text-danger"
                           *ngIf="settingsForm.get('email').errors.required">
                            Your email is required.
                        </small>
                        <small class="form-text text-danger"
                           *ngIf="settingsForm.get('email').errors.email">
                            Your email is invalid.
                        </small>
                        <small class="form-text text-danger"
                           *ngIf="settingsForm.get('email').errors.minlength">
                            Your email is required to be at least 5 characters.
                        </small>
                        <small class="form-text text-danger"
                           *ngIf="settingsForm.get('email').errors.maxlength">
                            Your email cannot be longer than 100 characters.
                        </small>
                    </div>
                </div>
                <div class="form-group" *ngIf="languages && languages.length > 0">
                    <label for="langKey">Language</label>
                    <select class="form-control" id="langKey" name="langKey" formControlName="langKey">
                        <option *ngFor="let language of languages" [value]="language">{{language | findLanguageFromKey}}</option>
                    </select>
                </div>
                <button type="submit" [disabled]="settingsForm.invalid" class="btn btn-primary">Save</button>
            </form>
        </div>
    </div>

</div>
